// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nFFI","newExpiryDate":"styles_newExpiryDate__2rIug","footer":"styles_footer__1N7OR"};